import { productTypeOptions } from "constants/SelectFieldOptions"
import { ApiTypes, UITypes } from "types"

const getProductTypeLabel = (type: string) => (type === "cwa" ? "CWA" : "Thermostat")

export const getReordersTableHeaderCells = ({
  onContractorSearchChange,
  onDeviceTypeChange,
}: {
  onContractorSearchChange: (value: string) => void
  onDeviceTypeChange: (option: UITypes.Option | null) => void
}): UITypes.TableHeaderCell[] => {
  return [
    {
      title: "Contractor Name",
      name: "contractor_name",
      size: "middle",
      type: "simple-search",
      onSearch: onContractorSearchChange,
    },
    {
      title: "Quantity",
      name: "quantity",
      size: "tiny",
      type: "default",
    },
    {
      title: "Device Type",
      name: "product_type",
      size: "small",
      type: "simple-select",
      options: productTypeOptions.map(option => ({
        label: getProductTypeLabel(option.value),
        value: option.value,
      })),
      onSelect: onDeviceTypeChange,
    },
    {
      title: "Date",
      name: "date",
      type: "default",
      size: "small",
    },
    {
      title: "Author",
      name: "username",
      type: "default",
      size: "small",
    },
  ]
}

export const convertReordersToTableRows = (
  responseData?: { data: ApiTypes.Res.ReordersData[] } | ApiTypes.Res.ReordersData[],
): UITypes.TableBodyRow[] => {
  const dataArray = Array.isArray(responseData) ? responseData : responseData?.data
  if (!dataArray?.length) return []

  return dataArray.map(
    reorder =>
      ({
        contractor_name: { value: reorder.contractor_name },
        quantity: { value: reorder.quantity },
        product_type: { value: getProductTypeLabel(reorder.product_type) },
        date: { value: reorder.date },
        username: { value: reorder.username || "-" },
        rowSettings: {
          id: reorder.contractor_id,
        },
      }) as UITypes.TableBodyRow,
  )
}
